import React from 'react';
import _style from './CsLoading.scss';

export const CsLoading = () => {
  return (<div className={_style.ldsSpinner}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>);
}